import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { CanalInterface } from '@/shared/models/canal/canal.interface';
import { CanalFilter } from '@/shared/models/canal/canal.filter';
import store from '@/store';
import queryUtil from '@/shared/utils/query.util';
import { RegraInterface } from '@/shared/models/regra/regra.interface';
import { instanciaAxios } from './base.service';
// Models

const canais = 'canais';

export default class CanalService {
  async buscarTodos(): Promise<any> {
    return await instanciaAxios.get(canais)
      .then((response: any) => {
        const lista: Array<CanalInterface> = response.data;
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorId(id: number): Promise<any> {
    return await instanciaAxios.get(`${canais}/${id}`)
      .then((response: any) => {
        const canal: CanalInterface = response.data;
        return canal;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async buscarPorFiltro(filtro: CanalFilter): Promise<any> {
    const query = queryUtil.getQuery(filtro);
    return await instanciaAxios.get(`${canais}/pesquisa${query}`)
      .then((response: any) => {
        const lista: Array<CanalInterface> = response.data;
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Pesquisa concluída!');
        return lista;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async salvarAtualizar(body: CanalInterface): Promise<any> {
    if (body.id) {
      await instanciaAxios.put(`${canais}/${body.id}`, body)
        .then(() => {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Canal editado com sucesso!');
        })
        .catch((error: any) => {
          console.error(error.response);
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
          return Promise.reject();
        });
    } else {
      await instanciaAxios.post(canais, body)
        .then(() => {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Canal cadastrado com sucesso!');
        })
        .catch((error: any) => {
          console.error(error.response);
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
          return Promise.reject();
        });
    }
  }

  async excluir(canal: CanalInterface): Promise<any> {
    await instanciaAxios.delete(`${canais}/${canal.id}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Canal excluído com sucesso!');
      })
      .catch((error) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async vincularRegra(id: number, codigo: string): Promise<any> {
    await instanciaAxios.put(`${canais}/${id}/vincular-regra/${codigo}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Vinculo Efetuado!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async desvincularRegra(id: number): Promise<any> {
    await instanciaAxios.put(`${canais}/${id}/desvincular-regra`)
      .then(() => {
        // store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Regra desvinculada com sucesso!');
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async recuperarRegraPorCanal(id: number): Promise<any> {
    return await instanciaAxios.get(`${canais}/regra-vinculada/${id}`)
      .then((response: any) => {
        const regras: Array<RegraInterface> = response.data;
        return regras;
      })
      .catch((error: any) => {
        if (error.response.status === 500 && error.response.data.indexOf('No entity found for query') !== -1) {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Nenhuma Regra Vinculada!');
        } else {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        }
        console.error(error);
      });
  }

  async recuperarRegraPorCNPJSemSnackBar(id: number): Promise<any> {
    return await instanciaAxios.get(`${canais}/regra-vinculada/${id}`)
      .then((response: any) => {
        const regras: Array<RegraInterface> = response.data;
        return regras;
      })
      .catch((error: any) => {
        if (!(error.response.status === 500 && error.response.data.indexOf('No entity found for query') !== -1)) {
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        }
        console.error(error);
      });
  }
}
